import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TechnicalAlertsComponent } from './technical-alerts.component';
import { TechnicalAlertsService } from './technical-alerts.service';

@NgModule({
	imports: [CommonModule],
	declarations: [TechnicalAlertsComponent],
	exports: [TechnicalAlertsComponent],
	providers: [TechnicalAlertsService],
})
export class TechnicalAlertsModule { }
